// DashboardHome.jsx
import { useAuth } from '../context/AuthContext';
import AdminDashboard from '../pages/AdminDashboard';
import Home from '../pages/Home';
import { ROLES } from '../config/routes';

const HomeSwitcher = () => {
    const { userRole } = useAuth();
    
    return (
            userRole === ROLES.FUND_MANAGER ? 
               <Home/> : 
            userRole === ROLES.ADMIN ?
               <AdminDashboard/> 
            : <></>
    );
};

export default HomeSwitcher;
